export default "__VITE_ASSET__DNdqNSgN__"